import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../shared/dataservice.service';
import { User, UserType } from '../shared/misc-classes';
import { ConfigurationService } from '../shared/configuration.service';
@Component({
  selector: 'nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit {
  isopen:boolean = false;
  router:any;
  isUserImpEnabled:boolean = false;
  userLogged:string;
  userList:Array<User>;
  userGroupList:Array<any>;

  @ViewChild('userImpForm',{static: false}) userImpFrm;


  constructor(private _router: Router, public _dataService:DataService, private _configurationService: ConfigurationService) { 
    this.router = _router;
  }

  ngOnInit() {
    //this.isUserImpEnabled = this._dataService.isAdmin;
    this.userLogged =  this._dataService.userId;
    if(this.userLogged == this._configurationService.getSingleEmail('NAV_MENU_ADMIN')){
      this.isUserImpEnabled = true;
    }
    this.loadReqData();
  }
  leavefunction(){
    this._dataService._currentSubMenuId = -1;
  }
  overfunction(_lnkOpt:number){    
    if(this._dataService._currentSubMenuId != _lnkOpt)
        this._dataService._currentSubMenuId = _lnkOpt;
    else
        this._dataService._currentSubMenuId = -1;
  }
  linkClicked(){
    this._dataService._currentSubMenuId = -1;
  }
  checkURL(_urlToken:string){
    let _url = this.router.url;
    if(_url.indexOf(_urlToken)>-1){
      return true;
    }
    else{
      return false;
    }
  }

  getWelcomeMessage():string{
    let _username:string = this._dataService.userName;
    if(_username != ''){
      return _username;//'Welcome, ' + _username;
    }
    return '';
  }

  private loadReqData(){
    if(this.isUserImpEnabled == true){
      this.userGroupList = [];
      this.userGroupList.push({"groupName":"Super Admin","enumRef":UserType.SUPER_ADMIN});
      this.userGroupList.push({"groupName":"Marketing","enumRef":UserType.MARKETING});
      this.userGroupList.push({"groupName":"HOD Marketing","enumRef":UserType.HOD_MARKETING});
      this.userGroupList.push({"groupName":"Project Management","enumRef":UserType.PROJECT_MANAGEMENT});
      this.userGroupList.push({"groupName":"HOD Project Management","enumRef":UserType.HOD_PROJECT_MANAGEMENT});
      this.userGroupList.push({"groupName":"Finance","enumRef":UserType.FINANCE});
      this.userGroupList.push({"groupName":"HOD Finance","enumRef":UserType.HOD_FINANCE});
      this.userGroupList.push({"groupName":"Mechanical Engineering","enumRef":UserType.MECHANICAL_ENGINEERING});
      this.userGroupList.push({"groupName":"Electrical Engineering","enumRef":UserType.ELECTRICAL_ENGINEERING});
      this.userGroupList.push({"groupName":"C30 Engineering","enumRef":UserType.C30_ENGINEERING});
      this.userGroupList.push({"groupName":"HOD Engineering","enumRef":UserType.HOD_ENGINEERING});
      this.userGroupList.push({"groupName":"SCM","enumRef":UserType.SCM});
      this.userGroupList.push({"groupName":"HOD SCM","enumRef":UserType.HOD_SCM});
      this.userGroupList.push({"groupName":"Planning","enumRef":UserType.PLANNING});
      this.userGroupList.push({"groupName":"Purchase","enumRef":UserType.PURCHASE});
      this.userGroupList.push({"groupName":"HOD Purchase","enumRef":UserType.HOD_PURCHASE});
      this.userGroupList.push({"groupName":"Production","enumRef":UserType.PRODUCTION});
      this.userGroupList.push({"groupName":"Planning & Productoin","enumRef":UserType.PLANNING_PRODUCTION});
      this.userGroupList.push({"groupName":"HOD Production","enumRef":UserType.HOD_PRODUCTION});
      this.userGroupList.push({"groupName":"Testing","enumRef":UserType.TESTING});
      this.userGroupList.push({"groupName":"HOD Testing","enumRef":UserType.HOD_TESTING});
      this.userGroupList.push({"groupName":"Stores","enumRef":UserType.STORES});
      this.userGroupList.push({"groupName":"HOD Stores","enumRef":UserType.HOD_STORES});
      this.userGroupList.push({"groupName":"Logistics","enumRef":UserType.LOGISTICS});
      this.userGroupList.push({"groupName":"HOD Logistics","enumRef":UserType.HOD_LOGISTICS});
      this.userGroupList.push({"groupName":"Readonly","enumRef":UserType.UNKNOWN});

      this._dataService.getUserList().subscribe((_users:Array<User>) => {

        if(_users){
          this.userList = _users;
        }

      });
    }
  }

  getUsersForGroup(_usrGrpRef){
    return this.userList.filter((_user:User) => {
      return this._dataService.getUserTypeFrmUserGrpId(_user.userGroupId) == _usrGrpRef;
    })
  }

  postUserImp(_evnt){
    let _targetUser:string = _evnt.srcElement.value;
    this.userLogged = _targetUser;

    setTimeout(() => {
      this.userImpFrm.nativeElement.submit()  
    }, 10);
    
  }
}
